import React from 'react';
import { Box, Typography, Grid, Checkbox } from '@mui/material';
import CloseIcon from '../../../assets/img/close.svg';
import CheckboxIcon from '../../../assets/img/iconCheckbox.svg';
import CheckedIcon from '../../../assets/img/checked.svg';
import { Section, Selected } from '../props';
import theme from '../../../constants/theme';
import { FilledButtonStyled } from '../../button/filledButtonStyled';
import { t } from '../../../utils/translate';

type Props = {
  item: Section;
  isMobile: boolean;
};

type Option = {
  value: string;
  count: number;
};

export const InputsSection = ({ item, isMobile }: Props) => {
  const updateCount = (
    arrOptions: Option[],
    arrSelected: Option[]
  ): Option[] => {
    return arrSelected.map((selectedItem) => {
      const matchingOption = arrOptions.find(
        (option) => option.value === selectedItem.value
      );
      return matchingOption
        ? { ...selectedItem, count: matchingOption.count }
        : selectedItem;
    });
  };

  const count = (arrOptions: Option[], arrSelected: Option[]): number => {
    if (arrSelected && arrSelected.length) {
      let newArr = updateCount(arrOptions, arrSelected);
      return newArr.reduce((a, v) => (a = a + v.count), 0);
    }

    if (arrOptions && arrOptions.length) {
      return arrOptions.reduce((a, v) => (a = a + v.count), 0);
    }

    return 0;
  };

  const isSelected = (arrSelected: Array<Selected>, label: string) => {
    return Boolean(arrSelected?.find((a: Selected) => a.value === label));
  };

  return (
    <Box>
      <Box display="flex" marginBottom="16px" justifyContent="space-between">
        <Box display="flex">
          <Typography variant="h3" fontWeight={600} sx={{ color: '#0F8345' }}>
            {count(item.options, item.arrSelected)}
          </Typography>
          <Typography
            color={theme.palette.text.secondary}
            variant="h3"
            sx={{ marginLeft: '10px' }}
          >
            {t('Stellenangebote gefunden')}
          </Typography>
        </Box>
        {!isMobile && (
          <Box
            position="relative"
            bottom="16px"
            onClick={item.handleClose}
            sx={{ cursor: 'pointer' }}
          >
            <img src={CloseIcon} alt="Close" />
          </Box>
        )}
      </Box>
      <Grid container columnSpacing={4} rowSpacing={2}>
        {item.options &&
          item.options.map((option: Selected, index: number) => (
            <Grid
              item
              md={4}
              xs={12}
              key={index}
              sx={{ display: 'flex', alignItems: 'start' }}
            >
              <Checkbox
                sx={{ padding: 0 }}
                icon={<img src={CheckboxIcon} />}
                checkedIcon={<img src={CheckedIcon} />}
                onChange={() => {
                  let newArr: Array<Selected> = item.arrSelected;

                  if (newArr.find((t: Selected) => t.value === option.value)) {
                    newArr = newArr.filter(
                      (t: Selected) => t.value !== option.value
                    );
                  } else {
                    newArr = [...item.arrSelected, option];
                  }

                  item.setArrOptions(newArr);
                }}
                checked={isSelected(item.arrSelected, option.value)}
              />
              <Typography
                variant="subtitle2"
                color={theme.palette.text.secondary}
                fontWeight={400}
                sx={{
                  marginLeft: '10px',
                  maxWidth: isMobile ? 'unset' : '160px',
                }}
              >
                {option.value} ({option.count})
              </Typography>
            </Grid>
          ))}

        {!isMobile && (
          <Grid
            item
            md={12}
            sx={{
              display: 'flex',
              alignItems: 'start',
              paddingTop: '16px !important',
              paddingBottom: '32px',
              position: 'sticky',
              bottom: 0,
              background: 'white',
              width: '100%'
            }}
          >
            <Box display="flex" alignItems="center" gap={4}>
              <FilledButtonStyled onClick={item.filter} disableRipple>
                {t('Anwenden')}
              </FilledButtonStyled>
              <Box onClick={item.handleClose}>
                <Typography
                  variant="h5"
                  color="primary"
                  fontWeight={600}
                  sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {t('Abbrechen')}
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
